import { ApiCodeSamples, ApiCodeSamplesConfig } from '../';

function displayValue(value: any) {
  return typeof value === 'string' ? `"${value}"` : value;
}

export function createSd3Examples(config: ApiCodeSamplesConfig, type: 'text' | 'image' = 'text'): ApiCodeSamples {
  const originalItems = Object.entries(config.body);

  const items = originalItems.filter(([key]) => {
    if (type === 'text') {
      return key !== 'strength';
    }

    if (type === 'image') {
      return key !== 'aspect_ratio';
    }
  });

  const imageName = config.body.prompt.split(' ')[0]
    ? config.body.prompt.split(' ')[0].toLowerCase()
    : '<DEFAULT_IMAGE_NAME>';

  // All options are strings, so for the short term we can just support strings
  const jsBody = items.reduce((acc, [key, value], index) => {
    if (key.toLowerCase() === 'authorization' || !Boolean(value)) {
      return acc;
    }

    if (index !== items.length - 1) {
      acc += `formData.append("${key}", "${value}"); \n`;
    } else {
      acc += `formData.append("${key}", "${value}");`;
    }

    return acc;
  }, '');

  const pyBody = items.reduce((acc, [key, value], index) => {
    if (!Boolean(value)) {
      return acc;
    }

    const displayVal = displayValue(value);

    if (index === 0) {
      acc += `${key}=${displayVal},\n`;
    } else if (index !== items.length - 1) {
      acc += `${key}=${displayVal},\n`;
    } else {
      acc += `      ${key}=${displayVal},`;
    }

    return acc;
  }, '');

  const curlBody = items.reduce((acc, [key, value], index) => {
    if (key.toLowerCase() === 'authorization' || !Boolean(value)) {
      return acc;
    }

    const displayVal = displayValue(value);

    if (index === 0) {
      acc += `-F ${key}=${displayVal} \\ \n`;
    } else if (index !== items.length - 1) {
      acc += `  -F ${key}=${displayVal} \\ \n`;
    } else {
      acc += `  -F ${key}=${displayVal} \\`;
    }

    return acc;
  }, '');

  const apiKey = config.body.authorization ? config.body.authorization : '<STABILITY_API_KEY>';

  let jsExample = `import fetch from "node-fetch"
import fs from "fs"


const formData = new FormData();
${jsBody}

(async () => {
      const response = await fetch("https://api.stability.ai/v2beta/stable-image/generate/sd3", {
    method: "POST",
    headers: {
      Accept: "image/*",
      Authorization: "Bearer sk-${apiKey}"
    },
    body: formData,
  });

  const buffer = await response.arrayBuffer()

  fs.writeFile('${imageName}.${config.body.output_format}', Buffer.from(buffer), () => console.log('finished downloading!'));
})().catch(console.error);

`;

  let curlExample = `curl -f -sS "https://api.stability.ai/v2beta/stable-image/generate/sd3" \\
  -H "authorization: Bearer ${apiKey}" \\
  -H "accept: image/*" \\
  ${curlBody}
  -o "./${imageName}.${config.body.output_format}"`;

  const pythonExample = `import requests

response = requests.post(
    f"https://api.stability.ai/v2beta/stable-image/generate/sd3",
    headers={
        "authorization": f"Bearer sk-${apiKey}",
        "accept": "image/*"
    },
    files={"none": ''},
    data={
      ${pyBody}
    },
)

if response.status_code == 200:
    with open("./${imageName}.${config.body.output_format}", 'wb') as file:
        file.write(response.content)
else:
    raise Exception(str(response.json()))`;

  return {
    typescript: jsExample,
    python: pythonExample,
    shell: curlExample,
  };
}
